{
 "title": {
  "x": 356,
  "y": 246,
  "w": 228,
  "h": 40,
  "lane": {
   "x": 280,
   "y": 232,
   "w": 380,
   "h": 70
  }
 },
 "name": {
  "x": 275,
  "y": 377,
  "w": 92,
  "h": 35,
  "lane": {
   "x": 260,
   "y": 366,
   "w": 440,
   "h": 64
  }
 },
 "what": {
  "x": 110,
  "y": 465,
  "w": 292,
  "h": 23,
  "lane": {
   "x": 104,
   "y": 458,
   "w": 456,
   "h": 42
  }
 },
 "q1": {
  "x": 226,
  "y": 529,
  "w": 477,
  "h": 39,
  "lane": {
   "x": 216,
   "y": 514,
   "w": 584,
   "h": 70
  }
 },
 "q2": {
  "x": 226,
  "y": 639,
  "w": 300,
  "h": 32,
  "lane": {
   "x": 216,
   "y": 624,
   "w": 584,
   "h": 70
  }
 },
 "q3": {
  "x": 225,
  "y": 749,
  "w": 508,
  "h": 32,
  "lane": {
   "x": 216,
   "y": 734,
   "w": 584,
   "h": 70
  }
 },
 "q4": {
  "x": 226,
  "y": 859,
  "w": 522,
  "h": 40,
  "lane": {
   "x": 216,
   "y": 844,
   "w": 584,
   "h": 70
  }
 },
 "q5": {
  "x": 225,
  "y": 969,
  "w": 323,
  "h": 32,
  "lane": {
   "x": 216,
   "y": 954,
   "w": 584,
   "h": 70
  }
 },
 "q6": {
  "x": 225,
  "y": 1079,
  "w": 306,
  "h": 40,
  "lane": {
   "x": 216,
   "y": 1064,
   "w": 584,
   "h": 70
  }
 },
 "note": {
  "x": 184,
  "y": 1218,
  "w": 573,
  "h": 31,
  "lane": {
   "x": 150,
   "y": 1204,
   "w": 650,
   "h": 60
  }
 },
 "block": {
  "x": 110,
  "y": 1335,
  "w": 413,
  "h": 23,
  "lane": {
   "x": 104,
   "y": 1318,
   "w": 536,
   "h": 58
  }
 },
 "just": {
  "x": 174,
  "y": 1462,
  "w": 206,
  "h": 32,
  "lane": {
   "x": 150,
   "y": 1456,
   "w": 260,
   "h": 50
  }
 },
 "send": {
  "x": 541,
  "y": 1462,
  "w": 238,
  "h": 25,
  "lane": {
   "x": 520,
   "y": 1456,
   "w": 280,
   "h": 50
  }
 }
}